import dayjs from "dayjs";

export function stripTime(date: Date) {
  date.setHours(0, 0, 0, 0);
  return date;
}

export function parseIsoToDate(input?: string | Date | null): Date | undefined {
  if (!input) return undefined;
  if (input instanceof Date) return input;
  const s = String(input);
  const normalized = s.replace(/\.(\d{3})\d*Z$/, ".$1Z");
  const parsed = dayjs(normalized);
  return parsed.isValid() ? parsed.toDate() : undefined;
}
